import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

import useStyles from './Styles/ProviderSubmitSkeleton.skeleton.style'

export default function ProviderSubmitSkeleton() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.inputsSkeleton}>
        <div className={classes.inputsContainerSkeleton}>
          <div className={classes.inputSection}>
            <div className={classes.inputProviderNameSkeleton}>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
            <div className={classes.inputProviderPullSkeleton}>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
              <Typography
                variant="body1"
                className={classes.typographySkeleton}>
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
          </div>
          <div className={classes.switchAndButtonSkeleton}>
            <Typography
              variant="body1"
              className={classes.typographySkeletonSwitch}>
              <Skeleton animation="wave" className={classes.skeletonSwitch} />
            </Typography>
            <Typography
              variant="body1"
              className={classes.typographySkeletonButton}>
              <Skeleton animation="wave" className={classes.skeletonSwitch} />
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
